// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kfJwN","badges":"styles_badges__2HdN7"};